import React, { Fragment, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Hero from "../../components/hero/Hero";
import Quote from "../../components/quote/quote";
import CoupleSection from "../../components/CoupleSection/CoupleSection";
import StorySection from "../../components/StorySection/StorySection";
import RsvpSection from "../../components/RsvpSection/RsvpSection";
import EventSection from "../../components/EventSection/EventSection";
import PortfolioSection from "../../components/PortfolioSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";


const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = "Compromiso Vivi & Ricky";
  }, []);

  return (
    <Fragment>
      <main>
        <Navbar />
        <Hero />
        <Quote />
        <CoupleSection />
        <StorySection />
        <RsvpSection rClass="pt-0" />
        <EventSection />
        <PortfolioSection/>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HomePage;
